export const siteInfo = {
  name: '蘑菇TV入口',
  tagline: '蘑菇TV官方最新入口地址直达',
  description: '找蘑菇TV入口？本页提供蘑菇TV入口最新官方地址、备用入口及快速访问指南，帮助用户第一时间进入蘑菇TV，享受高清直播与视频内容，解决入口失效、无法访问等常见问题。',
  keywords: '蘑菇tv入口,蘑菇tv官方入口,蘑菇tv最新入口,蘑菇tv备用入口,蘑菇tv网址,蘑菇tv直播入口,蘑菇tv访问地址',
  url: 'https://mogutv.entry',
  email: 'contact@mogutv.entry',
  foundingYear: 2020,
  brandStory: `蘑菇TV入口导航站成立于2020年，是国内最早专注于蘑菇TV访问导航的专业平台之一。我们的创始团队成员来自互联网和直播行业，深知用户在访问蘑菇TV时可能遇到的各种困难。

成立至今，我们始终坚持为用户提供最新、最快、最稳定的蘑菇TV入口信息。我们的入口监控系统7×24小时不间断运行，一旦发现官方入口变动，第一时间更新网站信息，确保用户始终能够访问到正确的蘑菇TV地址。

我们的愿景是成为蘑菇TV用户最信赖的导航平台。无论您是蘑菇TV的新用户还是老用户，无论您遇到入口失效、加载缓慢还是其他访问问题，我们都将竭诚为您提供帮助。`,
  features: [
    {
      title: '实时更新',
      description: '7×24小时监控官方入口状态，地址变更即时更新，确保您获取的永远是最新信息。',
      icon: 'ri-timer-flash-line',
    },
    {
      title: '多端覆盖',
      description: '覆盖PC端、移动端、TV端全部访问方式，满足不同设备用户的访问需求。',
      icon: 'ri-device-line',
    },
    {
      title: '安全可靠',
      description: '所有入口地址经过严格验证，杜绝仿冒网站，保护用户信息安全。',
      icon: 'ri-shield-check-line',
    },
    {
      title: '专业支持',
      description: '提供详细的使用教程和故障排查指南，帮助用户解决各种访问问题。',
      icon: 'ri-customer-service-2-line',
    },
  ],
  stats: [
    { value: '500万+', label: '累计服务用户' },
    { value: '99.9%', label: '入口可用率' },
    { value: '24/7', label: '全天候监控' },
    { value: '5年+', label: '运营经验' },
  ],
  faqs: [
    {
      question: '蘑菇TV入口地址会经常变更吗？',
      answer: '蘑菇TV官方入口地址相对稳定，但在服务器升级、域名调整等情况下可能会发生变化。我们会在地址变更后第一时间更新本站信息，建议您收藏本页面以获取最新入口地址。',
    },
    {
      question: '为什么我的蘑菇TV打不开？',
      answer: '蘑菇TV无法打开可能有多种原因：1）您的网络连接不稳定；2）浏览器缓存需要清理；3）DNS解析异常；4）所在地区网络限制。建议先尝试使用本站提供的备用入口，并按照我们的故障排查指南逐步检查。',
    },
    {
      question: '蘑菇TV有手机App吗？',
      answer: '是的，蘑菇TV提供iOS和Android官方App。iOS用户可在App Store搜索下载，Android用户可在各大应用商店获取。使用官方App可以获得比网页版更加流畅的观看体验。',
    },
    {
      question: '如何确认访问的是蘑菇TV官方网站？',
      answer: '请通过本站提供的入口地址访问蘑菇TV。官方网站具有以下特征：正规的HTTPS加密连接、完整的网站功能、官方认证标识。如发现可疑网站，请及时向我们反馈。',
    },
    {
      question: '蘑菇TV收费吗？',
      answer: '蘑菇TV提供免费直播和点播内容，用户可以免费观看大部分内容。同时蘑菇TV也提供VIP会员服务，会员可享受无广告观看、高清画质等专属权益。',
    },
    {
      question: '备用入口和官方入口有什么区别？',
      answer: '备用入口是官方在不同服务器节点部署的镜像站点，内容和服务与官方主站完全一致。当主站因网络原因访问较慢时，使用备用入口可以获得更快的访问速度。',
    },
  ],
  contactInfo: {
    email: 'support@mogutv.entry',
    wechat: 'mogutv_official',
    weibo: '@蘑菇TV导航',
    responseTime: '工作时间2小时内回复',
    workingHours: '周一至周日 9:00 - 22:00',
  },
};